var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_5354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1865 4.53027H14.8164V21.4677H25.1865V4.53027Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8846 13C15.8833 11.3691 16.253 9.75921 16.9658 8.29227C17.6785 6.82533 18.7156 5.53974 19.9985 4.53278C18.4095 3.284 16.5013 2.50747 14.4918 2.29191C12.4824 2.07636 10.4528 2.43049 8.63515 3.31383C6.81745 4.19717 5.28494 5.57408 4.21277 7.2872C3.1406 9.00031 2.57202 10.9805 2.57202 13.0015C2.57202 15.0224 3.1406 17.0026 4.21277 18.7158C5.28494 20.4289 6.81745 21.8058 8.63515 22.6891C10.4528 23.5725 12.4824 23.9266 14.4918 23.711C16.5013 23.4955 18.4095 22.7189 19.9985 21.4702C18.7152 20.4629 17.6779 19.1768 16.9651 17.7093C16.2523 16.2418 15.8829 14.6314 15.8846 13Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3974 19.6747V19.3277H36.547V19.2559H36.1909V19.3277H36.3315V19.6747H36.3974ZM37.0885 19.6747V19.2559H36.9808L36.8551 19.5551L36.7295 19.2559H36.6218V19.6747H36.6995V19.3576L36.8162 19.6299H36.897L37.0137 19.3576V19.6747H37.0885Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4266 13.0003C37.4266 15.0214 36.8579 17.0018 35.7855 18.7149C34.7131 20.4281 33.1804 21.805 31.3625 22.6882C29.5445 23.5714 27.5148 23.9253 25.5052 23.7095C23.4957 23.4936 21.5874 22.7167 19.9985 21.4675C21.281 20.4597 22.3178 19.1737 23.0307 17.7067C23.7436 16.2397 24.114 14.6299 24.114 12.9988C24.114 11.3677 23.7436 9.75796 23.0307 8.29094C22.3178 6.82392 21.281 5.53797 19.9985 4.53011C21.5874 3.28095 23.4957 2.50404 25.5052 2.28818C27.5148 2.07232 29.5445 2.42622 31.3625 3.30943C33.1804 4.19265 34.7131 5.56953 35.7855 7.2827C36.8579 8.99587 37.4266 10.9762 37.4266 12.9973V13.0003Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_5354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.3112,
    height: 26,
    fill: "white",
    transform: "translate(0.344482)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercardIcon.a6f6a132df7983c7dcbdb74a0056cf23.svg";
export { ForwardRef as ReactComponent };